import { useEffect } from 'react';
import { Grid, Modal, ModalProps } from 'antd';

const { useBreakpoint } = Grid;

export type AntdModalProps = {
  preventScrollOnMobile?: boolean;
} & ModalProps;

export const AntdModal = ({
  open,
  children,
  preventScrollOnMobile = false,
  ...rest
}: AntdModalProps) => {
  const { md } = useBreakpoint();

  useEffect(() => {
    if (preventScrollOnMobile && !md && open) {
      // Detect iOS
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

      if (isIOS) {
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        document.body.style.overflow = 'hidden';
      }
    }

    return () => {
      if (preventScrollOnMobile && !md) {
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
      }
    };
  }, [open, md, preventScrollOnMobile]);

  return (
    <Modal open={open} {...rest}>
      {children}
    </Modal>
  );
};
